module.exports = __webpack_public_path__ + "media/bg.555a8a72.mp4";